<template>
  <component :is="currentComponent"></component>
</template>

<script>
import TelemedicineContentEn from './TelemedicineContent/TelemedicineContentEn.vue';
import TelemedicineContentPtBR from './TelemedicineContent/TelemedicineContentPtBR.vue';
import TelemedicineContentEs from './TelemedicineContent/TelemedicineContentEs.vue';
import { LANGUAGES } from '@/common/constants';

export default {
  props: {
    language: {
      type: String,
      default: LANGUAGES.EN
    }
  },
  computed: {
    currentComponent() {
      if (this.language === LANGUAGES.PT_BR) {
        return TelemedicineContentPtBR;
      }
      if (this.language === LANGUAGES.ES) {
        return TelemedicineContentEs;
      }
      return TelemedicineContentEn;
    }
  }
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
